<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    class="h-[60%] min-h-[10%] overflow-auto pt-8"
    closeable
  >
    <div v-if="loading" class="flex justify-center items-center pt-32">
      <i class="loading loading-ring loading-lg" />
    </div>
    <div v-else>
      <div class="mb-2">
        <h3 class="text-center text-base font-semibold">
          {{ $t("Dungeons.sprite.pleaseSelectSprite") }}
        </h3>
      </div>
      <div
        class="flex flex-wrap gap-2"
        v-if="dungeonStore.mateIdSpriteListMap[mateId]?.length"
      >
        <div
          v-for="item in dungeonStore.mateIdSpriteListMap[mateId]"
          :key="item.id"
          class="w-[80px] overflow-hidden"
          @click="onSelectSprite(item)"
        >
          <DungeonsSpriteAnimation :animations="item.animationzz!" />
          <p class="text-center text-sm line-clamp-1">{{ item.name }}</p>
        </div>
      </div>
      <div v-else class="flex flex-col justify-center items-center pt-10">
        <VanEmpty image-size="80" description="No sprite" />

        <button
          class="btn btn-primary btn-sm"
          @click="
            $router.push({
              name: 'spriteEdit',
              params: {
                uuid: dungeonStore.selectedMateUuid,
              },
            })
          "
        >
          {{ $t("Dungeons.sprite.createSpriteTips2") }}
        </button>
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { watch, ref } from "vue";
import { useDungeon } from "@/stores/dungeon";
import { MateSprite } from "@/types/game";
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  mateId: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["update:show", "update:selectedSprite"]);
const dungeonStore = useDungeon();
const loading = ref(false);

watch(
  () => [props.show, dungeonStore.selectedMateUuid],
  async ([show, selectedMateUuid]) => {
    if (show || selectedMateUuid === "") {
      loading.value = true;
      await dungeonStore.fetchMateSpriteList(props.mateId);
      loading.value = false;
    }
  }
);

const onSelectSprite = (sprite: MateSprite) => {
  emit("update:selectedSprite", sprite);
};
</script>
